export interface ResourceItem {
  id: number;
  title: string;
  description: string;
  type: 'video' | 'audio';
  category: string;
  thumbnail: string;
  duration: string;
  price: number;
  originalPrice?: number;
  downloadCount: number;
  updateTime: string;
  tags: string[];
}

export const resourcesData: ResourceItem[] = [
  {
    id: 1,
    title: '企业数字化转型实战课程',
    description: '全面解析企业数字化转型的关键步骤和最佳实践，帮助企业快速实现数字化升级。',
    type: 'video',
    category: '企业培训',
    thumbnail: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop',
    duration: '12:30:00',
    price: 299,
    originalPrice: 599,
    downloadCount: 3256,
    updateTime: '2024-03-15',
    tags: ['数字化转型', '企业管理', '实战课程'],
  },
  {
    id: 2,
    title: '数字营销全攻略',
    description: '从0到1掌握数字营销核心技能，包括SEO、SEM、社交媒体营销等全方位内容。',
    type: 'video',
    category: '营销课程',
    thumbnail: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop',
    duration: '08:45:00',
    price: 199,
    downloadCount: 2876,
    updateTime: '2024-03-14',
    tags: ['数字营销', 'SEO', 'SEM'],
  },
  {
    id: 3,
    title: '商业数据分析入门',
    description: '学习使用Excel、Python进行商业数据分析，掌握数据驱动决策的核心方法。',
    type: 'video',
    category: '数据分析',
    thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop',
    duration: '15:20:00',
    price: 399,
    originalPrice: 799,
    downloadCount: 2156,
    updateTime: '2024-03-13',
    tags: ['数据分析', 'Python', 'Excel'],
  },
  {
    id: 4,
    title: '企业品牌打造指南',
    description: '系统学习品牌定位、品牌传播、品牌维护等核心知识，打造强势企业品牌。',
    type: 'audio',
    category: '品牌课程',
    thumbnail: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&h=400&fit=crop',
    duration: '06:30:00',
    price: 99,
    downloadCount: 1876,
    updateTime: '2024-03-12',
    tags: ['品牌建设', '品牌传播', '企业管理'],
  },
  {
    id: 5,
    title: '供应链管理精讲',
    description: '深入讲解供应链管理的核心理念和实践方法，提升企业供应链效率。',
    type: 'video',
    category: '管理课程',
    thumbnail: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&h=400&fit=crop',
    duration: '10:15:00',
    price: 259,
    downloadCount: 1432,
    updateTime: '2024-03-11',
    tags: ['供应链', '管理', '效率提升'],
  },
  {
    id: 6,
    title: '电商运营实战技巧',
    description: '电商平台运营全攻略，涵盖店铺装修、产品上架、流量获取、转化提升等核心内容。',
    type: 'video',
    category: '电商课程',
    thumbnail: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&h=400&fit=crop',
    duration: '18:00:00',
    price: 499,
    originalPrice: 999,
    downloadCount: 4567,
    updateTime: '2024-03-10',
    tags: ['电商运营', '淘宝', '京东'],
  },
  {
    id: 7,
    title: '财务分析与报表解读',
    description: '学会读懂财务报表，掌握财务分析的核心方法，为企业决策提供数据支持。',
    type: 'video',
    category: '财务课程',
    thumbnail: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop',
    duration: '09:45:00',
    price: 199,
    downloadCount: 1234,
    updateTime: '2024-03-09',
    tags: ['财务分析', '报表', '企业管理'],
  },
  {
    id: 8,
    title: '团队管理与领导力',
    description: '提升团队管理能力，培养卓越领导力，打造高效执行团队。',
    type: 'audio',
    category: '管理课程',
    thumbnail: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=400&fit=crop',
    duration: '07:20:00',
    price: 149,
    downloadCount: 2345,
    updateTime: '2024-03-08',
    tags: ['团队管理', '领导力', '人力资源'],
  },
  {
    id: 9,
    title: 'AI人工智能应用入门',
    description: '了解AI技术原理，学习AI在各行业的应用场景，把握AI时代机遇。',
    type: 'video',
    category: '技术课程',
    thumbnail: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop',
    duration: '14:30:00',
    price: 599,
    originalPrice: 1299,
    downloadCount: 5678,
    updateTime: '2024-03-07',
    tags: ['人工智能', 'AI', '技术应用'],
  },
  {
    id: 10,
    title: '客户关系管理CRM',
    description: '系统学习CRM理论和实践，提升客户满意度和客户忠诚度。',
    type: 'video',
    category: '营销课程',
    thumbnail: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop',
    duration: '11:00:00',
    price: 299,
    downloadCount: 1876,
    updateTime: '2024-03-06',
    tags: ['CRM', '客户关系', '销售'],
  },
  {
    id: 11,
    title: '项目管理PMP精讲',
    description: 'PMP认证考试必备课程，系统学习项目管理知识体系。',
    type: 'video',
    category: '认证课程',
    thumbnail: 'https://images.unsplash.com/photo-1507925921958-8a62f3d1a50d?w=600&h=400&fit=crop',
    duration: '35:00:00',
    price: 899,
    originalPrice: 1999,
    downloadCount: 3456,
    updateTime: '2024-03-05',
    tags: ['PMP', '项目管理', '认证'],
  },
  {
    id: 12,
    title: '商务谈判技巧',
    description: '掌握商务谈判的核心技巧，提升谈判成功率，为企业争取最大利益。',
    type: 'audio',
    category: '商务课程',
    thumbnail: 'https://images.unsplash.com/photo-1556761175-b413da4baf0e?w=600&h=400&fit=crop',
    duration: '05:45:00',
    price: 129,
    downloadCount: 2134,
    updateTime: '2024-03-04',
    tags: ['谈判', '商务', '沟通'],
  },
];

export const resourceCategories = ['全部', '企业培训', '营销课程', '数据分析', '管理课程', '电商课程', '财务课程', '技术课程', '认证课程'];
